// Component Styles
const styles = theme => ({
  grow: {
    flexGrow: 1
  },

  toolbar: {
    borderBottom: `1px solid rgba(0, 0, 0, 0.12)`
  },

   controlContainer: {
    marginTop: 32,
    marginLeft: 24,
    marginRight: 24,
    padding: "24px 32px",
    background: "#fafafa",
    borderRadius: 12,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    display: "flex",
    flexDirection: "column",
    gap: 24,
  },

  controlRow: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },

  controlLabel: {
    fontWeight: 500,
    color: "#333",
    minWidth: 140,
  },

  controlStatus: {
    fontWeight: 500,
  },
})

export default styles
